import React from 'react';
import './Exhibition.css';
import exhibit from '../../../imgs/exhibition.webp';


const Exhibition = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">Disha injection molding machine PET600-S6 will be unveiled at the K 2022 Exhibition</h2>
                <p className="Material-date">Sep. 26, 2022</p>
                <div className="advantpl">
                    <img src={exhibit} alt="72 Cavity PET Preforms Machine" className="advantpla-image" />
                </div>
                <p className="Material-text">K 2022 The World’s No.1 Trade Fair for Plastics and
                    Rubber will be held on Oct. 19th-26th local time in Dusseldorf, Germany.</p>

            </div>
        </div>
    );
};
export default Exhibition;
